// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1WFeR","file":"styles_file__1p57_"};